import { IntegrationBadge } from 'models/InternalIntegrationSetting';
import BadgeComponent from 'components/badge/Badge';
import EliteIcon from 'assets/images/icons/integrations/elite.svg?react';
import FeaturedIcon from 'assets/images/icons/integrations/featured.svg?react';
import NewIcon from 'assets/images/icons/integrations/new.svg?react';
import IncludedForFreeIcon from 'assets/images/icons/integrations/included-for-free.svg?react';
import PreferredIcon from 'assets/images/icons/integrations/preferred.svg?react';
import { useTranslation } from 'react-i18next';
import { normalizeKey } from 'utils/localeUtils';

const MAP_INTEGRATION_BADGE_TYPE_PROPS = {
  [IntegrationBadge.ELITE]: {
    backgroundColor: '#FFF3CD',
    fontColor: '#997404',
    icon: <EliteIcon />,
  },
  [IntegrationBadge.FEATURED]: {
    backgroundColor: '#E7F1FF',
    fontColor: '#3A84D8',
    icon: <FeaturedIcon />,
  },
  [IntegrationBadge.NEW]: {
    backgroundColor: '#FFE5D0',
    fontColor: '#984C0C',
    icon: <NewIcon />,
  },
  [IntegrationBadge.INCLUDED_FOR_FREE]: {
    backgroundColor: '#E2D9F3',
    fontColor: '#3D0A91',
    icon: <IncludedForFreeIcon />,
  },
  [IntegrationBadge.PREFERRED]: {
    backgroundColor: '#D1E7DD',
    fontColor: '#0F5132',
    icon: <PreferredIcon />,
  },
};

const Badge = ({ type }: { type: IntegrationBadge }) => {
  const { t } = useTranslation();

  if (!MAP_INTEGRATION_BADGE_TYPE_PROPS[type]) {
    return null;
  }

  const { backgroundColor, fontColor, icon } =
    MAP_INTEGRATION_BADGE_TYPE_PROPS[type];

  return (
    <BadgeComponent
      backgroundColor={backgroundColor}
      fontColor={fontColor}
      outline
      data-intercom-target={`integration-badge-${type.toLowerCase()}`}
    >
      {icon}
      {t(normalizeKey(`pageIntegrations.table.badges.${type}`))}
    </BadgeComponent>
  );
};

export default Badge;
